import React from "react";
import { useIntl } from "react-intl";
import { FormWidgetProps } from "../../../../shared/widgets";
import { SectionLabel } from "../../../../shared/widgets/SectionLabel";
import { CategoryLimitsFormData } from "../../types/CategoryLimitsTypes";
import { CategoryLimitBlock } from "./CategoryLimitBlock";
import { Section } from "./CategoryLimitsField.styles";
import { categoryLimitsMessages } from "./CategoryLimitsField.messages";
import { useCategoryLimitsField } from "./useCategoryLimitsField";

/**
 * rjsf field of the synthetic `categoryLimits` property: one block per category of the section,
 * in the order received (blocks cannot be added or removed), and nothing when the section is not
 * visible.
 */
export function CategoryLimitsField({
  formData,
  errorSchema,
  onChange,
}: FormWidgetProps<CategoryLimitsFormData | undefined>) {
  const intl = useIntl();
  const { visible, blocks } = useCategoryLimitsField({ formData, errorSchema, onChange });
  if (!visible) {
    return null;
  }
  const title = intl.formatMessage(categoryLimitsMessages.sectionTitle);
  return (
    <Section aria-label={title}>
      <SectionLabel>{title}</SectionLabel>
      {blocks.map(block => (
        <CategoryLimitBlock key={block.view.category} {...block} />
      ))}
    </Section>
  );
}
